import { render, staticRenderFns } from "./ServiceCategoryAdd.vue?vue&type=template&id=63184942&"
import script from "./ServiceCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./ServiceCategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports